import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=afd4189e&scoped=true&lang=pug&"
import script from "./ProjectModal.vue?vue&type=script&lang=js&"
export * from "./ProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=afd4189e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4189e",
  null
  
)

export default component.exports